import { Center, Heading, VStack } from '@chakra-ui/react';
import React from 'react';

import { isProd } from '../../config';

const DevToolWrapper = ({
  children,
  title = 'Dev Tools',
}: {
  children: React.ReactNode;
  title?: string;
}) => {
  if (isProd) {
    return null;
  }

  return (
    <Center>
      <VStack
        align="left"
        borderWidth={2}
        borderColor="grayBlueish"
        borderRadius="lg"
        mt="10px"
        p="10px"
        w="300px"
      >
        <Heading textAlign="center">{title}</Heading>
        {children}
      </VStack>
    </Center>
  );
};

export default DevToolWrapper;
